import script from "./YieldTrend.vue?vue&type=script&setup=true&lang=ts"
export * from "./YieldTrend.vue?vue&type=script&setup=true&lang=ts"

import "./YieldTrend.vue?vue&type=style&index=0&id=8bed4bcc&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bed4bcc"]])

export default __exports__